package com.mps.asc_app.domain.places.model

import kotlinx.serialization.Serializable

@Serializable
data class Address(
    val formattedAddress: String,
    val street: String,
    val postalCode: String,
    val city: String,
    val country: String,
    val placeId: String,
    val lat: Double,
    val lng: Double
)